<template>
  <v-card v-if="toolPickup">
    <v-card-text>
      <h1 class="title">
        {{ toolPickup.pickupType }} #{{ toolPickup.orderNumber }}
        <span class="grey--text font-weight-regular">
          on
          {{ toolPickup.orderDate.toDate() | moment("MMM Do [at] h:mma") }}
          <v-chip
            class="ml-1"
            small
            dark
            v-show="toolPickup.status == 'closed'"
            color="red lighten-1"
            >Pickup Closed</v-chip
          >
          <v-chip
            class="ml-1"
            small
            dark
            v-show="toolPickup.status == 'cancelled'"
            >Pickup Cancelled</v-chip
          >
        </span>
      </h1>
      <v-simple-table dense class="order-details-table mt-3">
        <template v-slot:default>
          <tbody>
            <tr v-if="admin">
              <td class="pa-1 pl-0 grey--text" valign="top" width="80">
                Ordered By:
              </td>
              <td>
                {{ toolPickup.orderedBy.firstName }}
                {{ toolPickup.orderedBy.lastName }}
                <br />
                <a :href="`mailto:${toolPickup.orderedBy.email}`">
                  {{ toolPickup.orderedBy.email }}
                </a>
                <br />
                {{ toolPickup.orderedBy.phone }}
              </td>
            </tr>
            <tr>
              <td class="pa-1 pl-0 grey--text" valign="top" width="80">
                Address:
              </td>
              <td>{{ toolPickup.jobSite.address }}</td>
            </tr>
            <tr>
              <td class="pa-1 pl-0 grey--text" valign="top">Pickup:</td>
              <td>
                {{ toolPickup.pickupDay.displayDate }}
                {{ toolPickup.pickupTime }}
              </td>
            </tr>
            <tr>
              <td class="pa-1 pl-0 grey--text" valign="top">Notes:</td>
              <td>{{ toolPickup.notes }}</td>
            </tr>
            <tr v-if="toolPickup.returnNote">
              <td class="pa-1 pl-0 grey--text" valign="top">Note (Yard):</td>
              <td>{{ toolPickup.returnNote }}</td>
            </tr>
            <tr v-if="toolPickup.status == 'closed'">
              <td class="pa-1 pl-0 grey--text" valign="top">Closed:</td>
              <td>
                {{ toolPickup.closeDate.toDate() | moment("MMM Do") }}
                <span v-if="toolPickup.closedBy">
                  by {{ toolPickup.closedBy.firstName }}
                  {{ toolPickup.closedBy.lastName }}
                </span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <div v-if="toolPickup.attestation" class="mt-4">
        <div class="caption grey--text">Demobilization Attestation</div>
        <p class="body-2 mb-2">{{ toolPickup.attestation.text }}</p>
        <img
          v-if="toolPickup.attestation.signatureData"
          :src="toolPickup.attestation.signatureData"
          style="max-width: 260px; border: 1px solid #ccc;"
        />
        <div class="caption mt-1" v-if="toolPickup.attestation.signedBy">
          Signed by {{ toolPickup.attestation.signedBy.firstName }}
          {{ toolPickup.attestation.signedBy.lastName }}
          <span v-if="toolPickup.attestation.signedAt">
            on
            {{
              toolPickup.attestation.signedAt.toDate()
                | moment("MMM Do, YYYY [at] h:mma")
            }}
          </span>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["toolPickup", "admin"],
  data() {
    return {};
  },
};
</script>
